import React, { useState, useEffect } from "react";

import {
  FieldContainer,
  InputField,
  InputFieldContainer,
  TableContainer,
  TableBody,
  TableRow,
  TableColumn,
  TableHead,
  TableHeader,
  ColumnTitle,
  TableTitle,
  BtnUpload,
  DisplayFlex2,
  ModalBASE64,
  CustomButton,
  FlexFieldContainer,
  ButtonEditar,
  SkeletonContainer,
  BtnSkeleton,
  LoadingCircle,
  StatusDot,
} from "../../../CSSGlobal";
import {
  CiBadgeDollar,
  CiBarcode,
  CiBookmark,
  CiCalendar,
  CiCoinInsert,
  CiMail,
  CiMap,
  CiMapPin,
  CiPhone,
  CiRead,
  CiReceipt,
  CiShop,
  CiSquareRemove,
  CiUnread,
  CiUser,
} from "react-icons/ci";
import {
  Container,
  TableFilterNF,
  ContainerField,
  ContainerModal,
  DasCommentContainer,
  DasContainer,
  ModalValorFaturamento,
  XmlContainer,
  ModalRegistroNotas,
  ModalDadosDaNFE,
  ContainerSearch
} from "./styled";
import listTables from "../NotaFiscal/Config/tableTitles.json";
import model from "../NotaFiscal/Config/model.json";
import modelImportNfe from "../NotaFiscal/Config/modelImportNfe.json";
import axios from "axios";
import PropTypes from "prop-types";
import {
  Close,
  Col,
  ColumnIntem,
  ContainerDadosListNFE,
  DisplayFlex,
  IconOlho,
  InfoItem,
  ModalContent,
  ModalOverlay,
  PaginationBtn,
} from "../../../styledEvents";
import {
  Box,
  LinearProgress,
  Pagination,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  formatCEP,
  formatCNPJ,
  formatCPF,
  formatCurrency,
  formatTelefone,
  formatValueBrl,
} from "../../../function/utilis/function";
import {
  DatePicker,
  ConfigProvider,
  Space,
  Input,
  Button,
  Flex,
  Skeleton,
  Spin,
  message,
  Upload,
  Select,
  Alert,
  Popover,
  Menu,
  Badge,
  Modal,
  Tooltip,
  Checkbox
} from "antd";
import pTBR from 'antd/lib/locale/pt_BR';
import {
  BuildOutlined,
  DollarOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import ExcelJS from 'exceljs';
import ClassificacaoServicos from "../Modal/ClassificacaoServicos";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function NotaFiscal({ idClient }) { // removi esse onClose onClose, 
  const { TextArea } = Input;
  const [modelInputs, setModelInputs] = useState([model]); // array dos inputs e titulos
  const [modelImport, setModelImport] = useState(modelImportNfe); // array dos inputs e titulos do component "modalRegister"
  const [notasFiscais, setNotasFiscais] = useState(true);
  const [togenerate, setTogenerate] = useState(false);
  const [isTable, setIsTable] = useState(true);
  const [isBtnGerarDAS, setisBtnGerarDAS] = useState(false);
  const [isModalDetail, setIsModalDetail] = useState(false);
  const [isRegisterNFImport, setIsRegisterNFImport] = useState(false);
  const [isBuscarListNF, setisBuscarListNF] = useState(false);
  const [isVlrTotal, setIsVlrTotal] = useState(false);
  const [isModalConfirmRemocaoNfe, setIsModalConfirmRemocaoNfe] = useState(false);
  const [isValue, setIsValue] = useState(false);
  const [isTitleValue, setIsTitleValue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingFaturamento, setLoadingFaturamento] = useState(false);
  const [eventStatus, setEventStatus] = useState(true);
  const [disabledValue, setDisabledValue] = useState(true);
  const [btnSalvar, setBtnSalvar] = useState(false);
  const [isBtnEditNFE, setIsBtnEditNFE] = useState(true);
  const [isTabImportNFE, setIsTabImportNFE] = useState(false);
  const [fechartudo, setFechartudo] = useState(false);
  const [isEmitirRelatorioFaturamento, setIsEmitirRelatorioFaturamento] =
    useState(false);
  const [isModalConfirmRetificacao, setIsModalConfirmRetificacao] = useState(false);
  const [isConfirmGerarDas, setIsConfirmGerarDas] = useState(false);
  const [valueRetificacao, setValueRetificacao] = useState(null);
  const [valoresVisiveis, setValoresVisiveis] = useState(true);
  const [mensagem, setMensagem] = useState(true);

  const [selectedNFEId, setSelectedNFEId] = useState(null);
  const [totalFaturamento, setTotalFaturamento] = useState(0);
  const [faturamentoFormatado, setFaturamentoFormatado] = useState();
  const [totalParaApuracao, setTotalParaApuracao] = useState(null)

  //FIELDS IMPORT NF-e
  const [categoria, setCategoria] = useState("");
  const [tipoId, setTipoId] = useState("");
  const [categoriaId, setCategoriaId] = useState("");
  const [dataReferencia, setDataReferencia] = useState(new Date().toISOString());
  const [valor, setValor] = useState("");
  const [descricao, setDescricao] = useState("");

  const [base64NF, setBase64NF] = useState(null);

  const [fileBinary, setFileBinary] = useState(null);

  const [mostrarLeituraDaNota, setMostrarLeituraDaNota] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const dateFormat = "DD/MM/YYYY";
  // Definindo as datas de início e término como o primeiro e o último dia do mês anterior
  const [dataInicio, setDataInicio] = useState(dayjs().subtract(1, 'month').startOf('month'));
  const [dataTermino, setDataTermino] = useState(dayjs().subtract(1, 'month').endOf('month'));
  const [data, setData] = useState([]);
  const [dados, setDados] = useState([]);
  const [dadosAnexo, setDadosAnexo] = useState([]);

  const [page, setPage] = useState(1);
  const Numberpage = 5;
  const startIndex = (page - 1) * Numberpage;
  const slicedData = data.slice(startIndex, startIndex + Numberpage);

  const [originalData, setOriginalData] = useState([]);

  const { Dragger } = Upload;
  const [titleTable, setTitleTable] = useState(listTables);

  const [paginaAtual, setPaginaAtual] = useState(1);

  const [pdfUrl, setPdfUrl] = useState('');
  const [stringBase64, setStringBase64] = useState("");
  const [idNFE, setIdNFE] = useState(null);

  const [modalServicos, setModalServicos] = useState(false)

  const [valueSelectService, setValueSelectService] = useState();

  //FIELDS REGISTRAR NF-e
  const [nfeData, setNfeData] = useState({
    numero: null,
    servicoCodigoItem: "",
    dataEmissao: null,
    prestadorCnpj: "",
    prestadorIm: "",
    tomadorCep: "",
    tomadorEndereco: "",
    tomadorNumero: "",
    tomadorBairro: "",
    tomadorUf: "",
    servicoCnae: "",
    tomadorCnpj: "",
    tomadorCpf: "",
    tomadorRazaoSocial: "",
    tomadorIm: "",
    tomadorTelefone: "",
    tomadorEmail: "",
    servicoCodigoTributacao: "",
    servicoDiscriminacao: "",
    vlAliquota: null,
    vlBaseCalculo: null,
    vlCofins: null,
    vlCsll: null,
    vlDeducao: null,
    vlDescontoCondicionado: null,
    vlDescontoIncondicionado: null,
    vlInss: null,
    vlIr: null,
    vlIss: null,
    vlIssRetido: null,
    vlLiquidoNfse: null,
    vlOutrosRetidos: null,
    vlPis: null,
    vlServico: null,
  });

  const [inputSearchNfe, setInputSearchNfe] = useState("");
  const [isBuscaNFe, setIsBuscaNFe] = useState(false);

  const [originalDataVazio, setOriginalDataVazio] = useState(false);
  const [isDataVazio, setisDataVazio] = useState(false);

  const [modalExtratoSimplesDas, setModalExtrato] = useState(false) ;
  const [extratoSimplesBase64, setExtratoSimplesBase64] = useState ("")

  const [filtrarCanceladas, setFiltrarCanceladas] = useState(false);

  useEffect(() => {
    let height = document.documentElement.scrollHeight;
    window.parent.postMessage({ frameHeight: height }, "*");
  },);

  useEffect(() => {
    setModelInputs(model);
    setModelImport(modelImport);
  }, [dadosAnexo]);

  useEffect(() => {
    if (Array.isArray(dados) && dados.length > 0) {
      salvarRegisterNFE();
    }
  }, [dados]);
  
  useEffect(() => {
    if (idClient) {
      fetchDataDas(idClient);
    } else {
      console.error("idClient está undefined");
    }
  }, [idClient]);

  useEffect(() => {
    fetchDataBusca();
  }, []); 

  // contexto das
  const fetchDataDas = async (idClient) => {
    const url = "/portal/rest/contador/cliente/contexto";
    const param = {
      id: idClient
    }

    try {
      const response = await axios.post(url, param, { withCredentials: true });
      // setShowNf(true);
    } catch {
      toast.error("Não foi possível encontrar as informações de contexto.")
    }
  }

  const handleKeyDownBuscar = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
  
      if (!loading) { // Impede chamadas repetidas
        setLoading(true);
        fetchDataBusca();
      }
    }
  };
  
  //ESSA FUNÇÃO FAZ A BUSCA DAS NOTAS PELOS PARAMETROS (DATA INICIO E TERMINO)
  const fetchDataBusca = async () => {
    setIsBuscaNFe(false);
    setisBtnGerarDAS(false);
    if (dataInicio === "" || dataInicio === null) {
      toast.warn("Digite uma data de Início");
      return;
    }
    if (dataTermino === "" || dataTermino === null) {
      toast.warn("Digite uma data Final");
      return;
    }

    dayjs(dataInicio).format('DD/MM/YYYY');
    dayjs(dataTermino).format('DD/MM/YYYY');

    //aqui ele verifica se o usuário escolheu a data entre o dia 01 e o final do mês, se ele não filtrar por esse esquema, o btn Gerar Das não irá ser mostrado
    const inicioValido = dayjs(dataInicio).date() === 1;
    const fimValido = dayjs(dataTermino).isSame(dayjs(dataTermino).endOf('month'), 'day');
    const mesmoMes = dayjs(dataInicio).isSame(dataTermino, 'month') && dayjs(dataInicio).isSame(dataTermino, 'year');

    if (!inicioValido || !fimValido || !mesmoMes) {
      //toast.error("Datas inválidas. A data inicial deve ser o dia 1 e a data final deve ser o último dia do mês, e ambas as datas devem estar no mesmo mês.");
      setisBtnGerarDAS(false);
    }

    try {
      const url = "/portal/rest/fiscal/nf/nfse/pesquisar";
      const data = {
        dataInicio: dataInicio,
        dataTermino: dataTermino,
      };
      setLoading(true);

      const response = await axios.post(url, data, { withCredentials: true });

      if (response.data && response.data.length > 0) {
        setData(response.data);
        setOriginalData(response.data);
        console.log(response.data)

        const totalVlServico = response.data
        .filter(item => item.cancelada !== true) // ignora os cancelados para somar o valor do faturamento (ele faz um filtro pelas canceladas para poder somar dentro da function reduce)
        .reduce((acc, curr) => acc + parseFloat(curr.vlServico), 0);


        const totalVlServicoFormatted = totalVlServico.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        setFaturamentoFormatado(totalVlServicoFormatted);
        setTotalFaturamento(totalVlServico);
        setTotalParaApuracao(totalVlServico);
        setIsEmitirRelatorioFaturamento(true);
        setIsVlrTotal(true);
        setisDataVazio(false);
        setIsBuscaNFe(true);
        setisBtnGerarDAS(inicioValido && fimValido && mesmoMes);
        setLoading(false);
      } else {
        setTotalFaturamento(0);
        setTotalParaApuracao(0);
        setFaturamentoFormatado("R$ 0");
        setisDataVazio(true);
        setIsVlrTotal(true);
        setIsEmitirRelatorioFaturamento(false);
        setIsBuscaNFe(false);
        setOriginalData([]);
        setData([]);
        setisBtnGerarDAS(true);
        setLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        toast.error("Erro 403 - Acesso negado");
      } else {
        console.log("Erro ao buscar os dados", error);
        toast.error("Erro ao buscar os dados", error);
      }
      setLoading(false);
    } finally {
      return;
    }
  };

  const onChangeValueDateInicio = (date, dateString) => {
    setDataInicio(date);
  };

  const onChangeValueDateFim = (date, dateString) => {
    setDataTermino(date);
  };

  // Manipulador de mudança da categoria
  const handleChangeCat = (value) => {
    setCategoria(value);

    const categoriaMap = {
      "Nota Fiscal de Serviço Prestado": "0",
      "Nota Fiscal de Serviço Tomado": "1",
      "Nota Fiscal de Venda de Produto": "2",
      "Nota Fiscal de Compra de Produto": "3",
    };
    const categoriaValue = categoriaMap[value];
    setCategoriaId(categoriaValue)

    const tipoMap = {
      "Nota Fiscal de Serviço Prestado": "P",
      "Nota Fiscal de Serviço Tomado": "T",
      "Nota Fiscal de Venda de Produto": "V",
      "Nota Fiscal de Compra de Produto": "C",
    };
    const tipoValue = tipoMap[value];
    setTipoId(tipoValue)

    console.log("Você selecionou: ", value, "com o tipo id:", tipoValue, "e o tipo de categoria: ", categoriaValue);

    // Verifica se a categoria selecionada é uma das três últimas
    if (
      value === "Nota Fiscal de Venda de Produto" ||
      value === "Nota Fiscal de Compra de Produto" ||
      value === "Nota Fiscal de Serviço Tomado"
    ) {
      setIsValue(true);
      setIsTitleValue(true);
    } else {
      setIsValue(false);
      setIsTitleValue(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //==================================================================//
  // 1 - LIDAR COM CAMPOS RENDERIZADOS DO IMPORTAR NOTAS
  const handleRenderedFieldsImport = (inputName, value) => {
    const setters = {
      categoria: setCategoria,
      dataReferencia: setDataReferencia,
      valor: setValor,
      descricao: setDescricao,
      base64NF: setBase64NF,
    };

    setters[inputName](value);
  };

  // 2 - COMPONENT DE RENDERIZAÇÃO DE CAMPOS IMPORTAR NOTA
  const renderNFImport = (step, value) => {

    if (!step || !step.inputs) {
      return null;
    }

    const values = {
      categoria,
      valor,
      base64NF,
      //dataReferencia,
      //descricao,
    };

    return step.inputs.map((inputName, index) => (
      <div key={index}>
        <InputFieldContainer>
          <div className="display-flex">
            <label className="title-input">{inputName.title === "valor" ? isTitleValue && inputName.title : inputName.title}</label>
          </div>
        </InputFieldContainer>


        <InputFieldContainer style={{width: "100%"}}>
          {inputName.input === "categoria" ? (
              <Select
                defaultValue="Selecione"
                style={{ width: 320 }}
                onChange={handleChangeCat}
                options={[
                  {
                    value: "Nota Fiscal de Serviço Prestado",
                    label: "Nota Fiscal de Serviço Prestado",
                  },
                  {
                    value: "Nota Fiscal de Serviço Tomado",
                    label: "Nota Fiscal de Serviço Tomado",
                    disabled: true,

                  },
                  {
                    value: "Nota Fiscal de Venda de Produto",
                    label: "Nota Fiscal de Venda de Produto",
                    disabled: true,

                  },
                  {
                    value: "Nota Fiscal de Compra de Produto",
                    label: "Nota Fiscal de Compra de Produto",
                    disabled: true,

                  },
                ]}
              />
           
          ) : inputName.input === "base64NF" ? (
            <Dragger {...props} disabled={loading}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Click ou arraste o arquivo aqui</p>
              <p className="ant-upload-hint">
                Anexo documento da Nota Fiscal (tamanho máximo 5MB):
              </p>
            </Dragger>
          ) : inputName.input === "valor" ? isValue && (
            <Input
              className="inputStyled"
              type="text"
              value={values[inputName.input]}
              onChange={(e) =>
                handleRenderedFieldsImport(inputName.input, e.target.value)
              }
            />
          ) : (
            <Input
              className="inputStyled"
              type="text"
              value={values[inputName.input]}
              onChange={(e) =>
                handleRenderedFieldsImport(inputName.input, e.target.value)
              }
            />
          )}
        </InputFieldContainer>
      </div>
    ));

    /** // inputName.input === "dataReferencia" ? (
            <Space direction="vertical" size={12}>
              <ConfigProvider locale={pTBR}>
                <DatePicker
                  defaultValue={dayjs(dataReferencia)}
                  format={dateFormatList}
                  onChange={handleDateChange}
                />
              </ConfigProvider>
            </Space>
          )  */
  };

  //==================================================================//
  // 1 - LIDAR COM CAMPOS RENDERIZADOS DO RESGISTRO DE NOTAS
  const handleRenderedFields = (inputName, value) => {
    setNfeData((prevState) => ({
      ...prevState,
      [inputName]: value,
    }));

  };

  // 2 - RENDERIZAÇÃO DE CAMPOS REGISTRO DE NOTA
  const fieldRenderingNFE = (step) => {
    if (!step || !step.inputs) {
      return null;
    }

    return (
      <div>
        <ContainerField>
          <div className="title-tabs">
            <span>{step.text}</span>
          </div>

          <div>
            {step.inputs.map((inputName) => (
              <>
                <FlexFieldContainer key={inputName.input}>
                  <div className="col">
                    {inputName.title === "Discriminação" ? ( // Se por acaso alterar o nome do titulo no arquivo json, é também necessário mudar aqui também nessa condicional
                      <></>
                    ) : (
                      <label className="title-input">{inputName.title}</label>
                    )}
                  </div>

                  <div className="col">
                    {inputName.input === "dataEmissao" ? (
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={nfeData[inputName.input]}
                        disabled={disabledValue}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    ) : inputName.input === "prestadorCnpj" ||
                      inputName.input === "tomadorCnpj" ? (
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={formatCNPJ(nfeData[inputName.input])}
                        disabled={disabledValue}
                        maxLength={18}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    ) : inputName.input === "tomadorCep" ? (
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={formatCEP(nfeData[inputName.input])}
                        disabled={disabledValue}
                        maxLength={9}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    ) : inputName.input === "tomadorCpf" ? (
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={formatCPF(nfeData[inputName.input])}
                        disabled={disabledValue}
                        maxLength={14}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    ) : inputName.input === "tomadorTelefone" ? (
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={formatTelefone(nfeData[inputName.input])}
                        disabled={disabledValue}
                        maxLength={14}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    ) : inputName.input === "servicoDiscriminacao" ? (
                      <>
                        <div style={{ textAlign: "left" }}>
                          <label className="titleFiled1">Discriminação</label>
                          <br />
                          <TextArea
                            className={`inputStyled ${disabledValue ? "disabled" : ""
                              }`}
                            rows={6}
                            style={{ width: "400px" }}
                            value={nfeData[inputName.input]}
                            disabled={disabledValue}
                            onChange={(e) =>
                              handleRenderedFields(
                                inputName.input,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </>
                    ) : inputName.input === "tomadorCep" ? (
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={formatCEP(nfeData[inputName.input])}
                        disabled={disabledValue}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    ) : (
                      //para inputs normais sem maskaras aplica-se então este component Input do type text
                      <Input
                        type="text"
                        className={`inputStyled ${disabledValue ? "disabled" : ""
                          }`}
                        value={nfeData[inputName.input]}
                        disabled={disabledValue}
                        onChange={(e) =>
                          handleRenderedFields(inputName.input, e.target.value)
                        }
                      />
                    )}
                  </div>
                </FlexFieldContainer>
              </>
            ))}
          </div>
        </ContainerField>
      </div>
    );
  };

  function removerMascara(valor) {
    if (!valor) return ""; // Se for null, undefined ou vazio, retorna string vazia
    return valor.replace(/\D/g, ""); // Remove tudo que não for número
  }

  //SALVA REGISTRO DE NOTA
  const salvarRegisterNFE = async () => {
    setLoading(true);
    const url = "/portal/rest/fiscal/nf/nfse/ps/cadastro";

    const data = dados.length > 1 ? dados : [
      {
        numero: nfeData.numero,
        servicoCodigoItem: nfeData.servicoCodigoItem,
        dataEmissao: nfeData.dataEmissao,
        prestadorCnpj: removerMascara(nfeData.prestadorCnpj),
        prestadorIm: nfeData.prestadorIm,
        tomadorCep: removerMascara(nfeData.tomadorCep),
        tomadorEndereco: nfeData.tomadorEndereco,
        tomadorNumero: nfeData.tomadorNumero,
        tomadorBairro: nfeData.tomadorBairro,
        tomadorUf: nfeData.tomadorUf,
        servicoCnae: parseInt(nfeData.servicoCnae, 10),
        tomadorCnpj: removerMascara(nfeData.tomadorCnpj),
        tomadorCpf: nfeData.tomadorCpf
          ? removerMascara(nfeData.tomadorCpf)
          : null,
        tomadorRazaoSocial: nfeData.tomadorRazaoSocial,
        tomadorIm: nfeData.tomadorIm,
        tomadorTelefone: nfeData.tomadorTelefone
          ? removerMascara(nfeData.tomadorTelefone)
          : null,
        tomadorEmail: nfeData.tomadorEmail,
        servicoCodigoTributacao: nfeData.servicoCodigoTributacao,
        servicoDiscriminacao: nfeData.servicoDiscriminacao,

        tipoId: categoriaId, // pra enviar o tipoId também

        vlAliquota: nfeData.vlAliquota,
        vlBaseCalculo: nfeData.vlBaseCalculo,
        vlCofins: nfeData.vlCofins,
        vlCsll: nfeData.vlCsll,
        vlDeducao: nfeData.vlDeducao,
        vlDescontoCondicionado: nfeData.vlDescontoCondicionado,
        vlDescontoIncondicionado: nfeData.vlDescontoIncondicionado,
        vlInss: nfeData.vlInss,
        vlIr: nfeData.vlIr,
        vlIss: nfeData.vlIss,
        vlIssRetido: nfeData.vlIssRetido,
        vlLiquidoNfse: nfeData.vlLiquidoNfse,
        vlOutrosRetidos: nfeData.vlOutrosRetidos,
        vlPis: nfeData.vlPis,
        vlServico: nfeData.vlServico,
      },
    ];

    try {
      const response = await axios.post(url, data, { withCredentials: true });
      if (response.status === 200) {
        setLoading(false);
        const idNFe = response.data[0].id;
        setIdNFE(idNFe);
        //aqui eu chamo o endpoint /portal/rest/fiscal/nf/cadastrar
        await cadastrarNFE();
        await nfArquivoUploadId(idNFe);

        setEventStatus(true);
        setBtnSalvar(false);
        setIsBtnEditNFE(true);
        setDisabledValue(true);
        setMensagem(false);
        setIsTabImportNFE(false);
        setIsRegisterNFImport(false);
        toast.success("NF-e salva com sucesso!");
        //aqui eu chamo o endpoint /portal/rest/fiscal/nf/arquivo/upload?id=${id}
        //window.location.reload();
        setCategoria("");
        setDescricao("");
        setDataReferencia(new Date().toISOString());
        setBase64NF(null);
        setValor("");
        setIsTabImportNFE(false);
        setMensagem(false);
        setMostrarLeituraDaNota(0);

        // window.location.href = "#PortalNFSECliente";
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        toast.error(error.response.data)
      }
      if (error.response && error.response.status === 403) {
        message.error("Erro 403 - Acesso negado");
      }
    } finally {
      setLoading(false);
    }
  };

  //sem service
  const cadastrarNFE = async () => {
    const url = "/portal/rest/fiscal/nf/cadastrar";


    const data = {
      id: "",
      categoria: {
        id: categoriaId,
      },
      tipo: {
        id: tipoId,
      },
      dataReferencia: dataReferencia,
      descricao: descricao,
      valor: valor,
    };

    //console.log("Resultado do data: ", data)
    setLoading(true);
    try {
      const response = await axios.post(url, data, { withCredentials: true });
      if (response.status === 200) {
        console.log("Enviado com sucesso!");
      } else {
        console.log("Erro no envio da inportação da Nota");
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        message.error("Erro 403 - Acesso negado");
      } else {
        console.log("Erro interno", error);
        toast.error("Erro interno", error);
      }
    } finally {
      setLoading(false);
    }
  }

  //sem service
  const validaNFEe = async () => {
    const url = "/portal/rest/fiscal/nf/nfse/ps/valida";
    const data = {
      base64NF: base64NF,
    };

    if (categoria === "") {
      toast.error("Todos os campos são obrigatório");
      return;
    }
    if (isValue === true && valor === "" || valor === null) {
      toast.error("Digite o valor");
      return;
    }
    if (base64NF === "" || base64NF === null) {
      toast.error("Você não anexou o arquivo");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(url, data);
      console.log("response:", response)

      if(response.data.erro){
        const erroCategoriaId = response.data.erro.categoria?.id;
        if (erroCategoriaId === "B") {
          toast.error(response.data.erro.mensagem || "Erro de categoria B");
        } else if (erroCategoriaId === "T") {
          toast.error(response.data.erro.mensagem || "Erro inesperado!");
        } 
      }

      if (!response.data || response.data.length === 0) {
        console.log("Nenhum dado retornado na resposta");
      }

      if (!response.data[0].dataEmissao) {
        console.log("dataEmissao não está presente na resposta");
      }

      let formattedDate = null;

      if (response.data[0].dataEmissao) {
        const adjustedTimestamp = response.data[0].dataEmissao; // Já está em milissegundos
        const date = new Date(adjustedTimestamp);
      
        if (isNaN(date)) {
          console.log("Data inválida");
        } else {
          formattedDate = format(date, "yyyy-MM-dd", { locale: ptBR });
          console.log("Data formatada: ", formattedDate);
        }
      }
      //console.log("Data formatada: ", formattedDate);
      if (response.status === 200 && Object.keys(response.data).length > 0) {
          //Se o objeto vim com 1 array eu mostro o modal, senão, eu faço o cadastro
          console.log("RESPOSTA DO DATA: ", response);
          if (response.data.length > 1) {
            setDados(response.data)
            //console.log("DADOS DO DATA", response.data)
          } else {
            //useStates para mostrar os dados que vem da leitura da nota
            setNfeData({
              numero: response.data[0].numero,
              servicoCodigoItem: response.data[0].servicoCodigoItem,
              dataEmissao: formattedDate,
              prestadorCnpj: response.data[0].prestadorCnpj,
              prestadorIm: response.data[0].prestadorIm,
              tomadorCep: response.data[0].tomadorCep,
              tomadorEndereco: response.data[0].tomadorEndereco,
              tomadorNumero: response.data[0].tomadorNumero,
              tomadorBairro: response.data[0].tomadorBairro,
              tomadorUf: response.data[0].tomadorUf,
              servicoCnae: response.data[0].servicoCnae,
              tomadorCnpj: response.data[0].tomadorCnpj,
              tomadorCpf: response.data[0].tomadorCpf,
              tomadorRazaoSocial: response.data[0].tomadorRazaoSocial,
              tomadorIm: response.data[0].tomadorIm,
              tomadorTelefone: response.data[0].tomadorTelefone,
              tomadorEmail: response.data[0].tomadorEmail,
              servicoCodigoTributacao: response.data[0].servicoCodigoTributacao,
              servicoDiscriminacao: response.data[0].servicoDiscriminacao || "Sem discriminação",
              vlAliquota: response.data[0].vlAliquota,
              vlBaseCalculo: response.data[0].vlBaseCalculo,
              vlCofins: response.data[0].vlCofins,
              vlCsll: response.data[0].vlCsll,
              vlDeducao: response.data[0].vlDeducao,
              vlDescontoCondicionado: response.data[0].vlDescontoCondicionado,
  
              vlDescontoIncondicionado: response.data[0].vlDescontoCondicionado,
              vlInss: response.data[0].vlInss,
              vlIr: response.data[0].vlIr,
              vlIss: response.data[0].vlIss,
              vlIssRetido: response.data[0].vlIssRetido,
              vlLiquidoNfse: response.data[0].vlLiquidoNfse,
              vlOutrosRetidos: response.data[0].vlOutrosRetidos,
              vlPis: response.data[0].vlPis,
              vlServico: response.data[0].vlServico,
            });
  
            setMostrarLeituraDaNota(1);
            setDados(nfeData);
            setIsTabImportNFE(true);
            toast.success("Leitura concluída com sucesso!");
            console.log(response.data)
            setMensagem(true);
          }
      } else {
      }
      if (response.status === 204) {
        toast.warn(response.data.mensagem);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 403) {
        toast.error("Erro 403 - Acesso negado");
      }
      if (error.response && error.response.status === 500) {
        toast.error(error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };

  // 2 - FAZ A LEITURA DO ARQUIVO com FileReader
  const handleFileChange = (info) => {
    const file = info.file.originFileObj || info.file;

    setFileBinary(file)

    if (Array.isArray(file) && file.length > 1) {
      message.error("Você só pode anexar um arquivo.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setBase64NF(e.target.result.split(",")[1]); // Remove o prefixo da string base64
    };
    reader.readAsDataURL(file);
  };

  // 3 - PROPS PARA SER USADO NA FUNÇÃO handleFileChange
  const props = {
    name: "file",
    multiple: false,
    accept: ".pdf, .txt, .xml, .csv, .zip",
    beforeUpload: () => false, // Impede o upload automático
    onChange: handleFileChange,
  };

  //==================================================================//
  //ABRIR MODAL DE DETALHAMENTO DA NOTA
  const openModalDetails = (id) => {
    setIsModalDetail(id);
  };

  //FECHAR MODAL DE DETALHE DA NOTA
  const closeModalDetails = () => {
    setIsModalDetail(false);
  };

  const nfArquivoUploadId = async (id) => {
    const url = `/portal/rest/fiscal/nf/arquivo/upload?id=${id}`;
    //console.log("idNFE:",idNFE);

    const formData = new FormData();
    formData.append('file', fileBinary);

    setLoading(true);

    try {
      const response = await axios.post(url, formData, { withCredentials: true });
      if (response.status === 204) {
        console.log("upload efetuado!");
      } else {
        toast.error("Erro ao salvar");
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        message.error("Erro 403 - Acesso negado");
      }
    } finally {
      setLoading(false);
    }
  };

  //FUNÇÃO DE EXCLUIR NOTA
  const deleteRegisterNFE = async (id) => {
    const url = `/portal/rest/fiscal/nf/nfse/ps/excluir`;
    setLoading(true);
    try {
      const dataa = data.find((dado) => dado.id === id);
      console.log(dataa);
      const response = await axios.post(url, dataa, { withCredentials: true });
      if (response.status === 204) {
        closeModalConfirm();
        await fetchDataBusca(); // Atualize os dados após a exclusão
        toast.success("NF-e excluída com sucesso!");
      } else {
        toast.error("Erro ao excluir NF-e");
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        message.error("Erro 403 - Acesso negado");
      } else if (error.message.startsWith("Registro com ID")) {
        //console.log("Erro ao excluir: " + error.message);
        toast.error(error.message);
      } else {
        console.log("Erro ao excluir", error);
        toast.error("Erro ao excluir NF-e");
      }
      return true; // deixa o modal aberto quando vier o erro
    } finally {
      setLoading(false);
    }
  };

  //HABILITA OS INPUTS PARA EDIÇÃO
  const editarField = () => {
    setBtnSalvar(true);
    setDisabledValue(false);
  };

  //ABRIR MODAL DE REGISTRAR NOTA
  const openModalRegisterNFE = () => {
    setIsRegisterNFImport(true);
  };

  //FECHAR MODAL DE REGISTRAR NOTA
  const closeModalRegisterNFE = () => {
    setIsRegisterNFImport(false);
    setIsTabImportNFE(false);
    setCategoria("");
    setDescricao("");
    setDataReferencia("");
    setBase64NF("");

    setIsTabImportNFE(false);
    setMensagem(false);
    setMostrarLeituraDaNota(0);
  };

  //MODAL DE DETALHAMENTO DA NOTA
  const modalDetails = (id) => {
    if (!data || data.length === 0) {
      return null;
    }

    const eventID = data.find((item) => item.id === id);

    if (!eventID) {
      return null;
    }

    return (
      <>
        <ModalDadosDaNFE>
          <DisplayFlex>
            <Close>
              <CiSquareRemove
                className="font-icon"
                onClick={closeModalDetails}
              />
            </Close>
          </DisplayFlex>

          <div className="title">
            <strong>Dados da Nota Fiscal</strong>
            <br />
            <span>Estruturação da Nota</span>
          </div>

          <ContainerModal>
            {data
              .filter((item) => item.id === id)
              .map((filterItem) => {
                return (
                  <ColumnIntem key={filterItem.id}>
                    <Col>
                      <InfoItem>
                        {filterItem.cancelada === true ? (
                          <Alert type="error" description="A NF-e em questão encontra-se cancelada." />
                        ): ""}
                        <div className="moreInfo">
                          <div>
                            <div className="titulo">
                              <label>Dados da NF-e </label>
                            </div>

                            <div>
                              <DisplayFlex>
                                <div className="col">
                                  <CiBarcode />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    N° NF-e:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.numero}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiBarcode />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Cod verificação:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    style={{ width: "350px" }}
                                    value={filterItem.serie}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>
                            </div>
                          </div>
                          <div>
                            <div className="titulo">
                              <label>Informações do Prestador </label>
                            </div>

                            <DisplayFlex>
                              <div className="col">
                                <CiCalendar />
                              </div>
                              <div className="col">
                                <label className="tituloLabel">
                                  Data de emissão:
                                </label>
                              </div>
                              <div className="col">
                                <Input
                                  className={`inputStyled ${eventStatus ? "disabled" : ""
                                    }`}
                                  value={filterItem.dataEmissao}
                                  disabled={eventStatus}
                                />
                              </div>
                            </DisplayFlex>

                            <DisplayFlex>
                              <div className="col">
                                <CiShop />
                              </div>
                              <div className="col">
                                <label className="tituloLabel">
                                  CNPJ do Prestador:
                                </label>
                              </div>
                              <div className="col">
                                <Input
                                  className={`inputStyled ${eventStatus ? "disabled" : ""
                                    }`}
                                  value={formatCNPJ(filterItem.prestadorCnpj)}
                                  disabled={eventStatus}
                                />
                              </div>
                            </DisplayFlex>

                            <DisplayFlex>
                              <div className="col">
                                <CiReceipt />
                              </div>
                              <div className="col">
                                <label className="tituloLabel">
                                  IM do prestador:
                                </label>
                              </div>
                              <div className="col">
                                <Input
                                  className={`inputStyled ${eventStatus ? "disabled" : ""
                                    }`}
                                  value={filterItem.prestadorIm}
                                  disabled={eventStatus}
                                />
                              </div>
                            </DisplayFlex>
                          </div>

                          <div>
                            <div className="titulo">
                              <label>Informações do Tomador </label>
                            </div>
                            <div>
                              <DisplayFlex>
                                <div className="col">
                                  <CiMap />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">CEP:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={formatCEP(filterItem.tomadorCep)}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiMapPin />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Endereço:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.tomadorEndereco}
                                    disabled={eventStatus}
                                  />{" "}
                                  -
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    style={{ width: "100px" }}
                                    value={filterItem.tomadorNumero}
                                    disabled={eventStatus}
                                  />{" "}
                                  |
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.tomadorBairro}
                                    disabled={eventStatus}
                                  />{" "}
                                  -
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    style={{ width: "100px" }}
                                    value={filterItem.tomadorUf}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiUser />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    CNPJ / CPF:
                                  </label>
                                </div>
                                <div className="col">
                                  {filterItem.tomadorCnpj === "" ||
                                    filterItem.tomadorCnpj === null ? (
                                    <Input
                                      className={`inputStyled ${eventStatus ? "disabled" : ""
                                        }`}
                                      value={formatCPF(filterItem.tomadorCpf)}
                                      disabled={eventStatus}
                                    />
                                  ) : "" ||
                                    filterItem.tomadorCpf === "" ||
                                    filterItem.tomadorCpf === null ? (
                                    <Input
                                      className={`inputStyled ${eventStatus ? "disabled" : ""
                                        }`}
                                      value={formatCNPJ(filterItem.tomadorCnpj)}
                                      disabled={eventStatus}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiUser />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Razão Social:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    style={{ width: "350px" }}
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.tomadorRazaoSocial}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiReceipt />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    IM Tomador:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.tomadorIm}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiPhone />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Telêfone:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.tomadorTelefone}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiMail />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">E-mail:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    style={{ width: "350px" }}
                                    value={filterItem.tomadorEmail}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>
                            </div>
                          </div>

                          <div>
                            <div className="titulo">
                              <label>Serviço Disciminação</label>
                            </div>
                            <div>
                              <DisplayFlex>
                                <div className="col">
                                  <CiBookmark />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Serviço código de tributação:
                                  </label>
                                </div>

                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    style={{ width: "200px" }}
                                    value={filterItem.servicoCodigoTributacao}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>
                            </div>

                            <div className="servicoDiscr">
                              <DisplayFlex>
                                <div className="col">
                                  <TextArea
                                    rows={6}
                                    style={{ width: "500px" }}
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.servicoDiscriminacao}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>
                            </div>
                          </div>

                          <div>
                            <div className="titulo">
                              <label>Valores da Nota </label>
                            </div>

                            <div>
                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Alíquota:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlAliquota}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Base de calculo:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlBaseCalculo}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">Cofins:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlCofins}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">CSLL:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlCsll}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Dedução:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlDeducao}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Desconto condicionado:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlDescontoCondicionado}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Desconto incondicionado:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlDescontoIncondicionado}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">INSS:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlInss}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">IR:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlIr}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">ISS:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlIss}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    ISS Retido:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlIssRetido}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Valor liquido da Nota:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlLiquidoNfse}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Outros valores retido:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlOutrosRetidos}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">PIS:</label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlPis}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>

                              <DisplayFlex>
                                <div className="col">
                                  <CiCoinInsert />
                                </div>
                                <div className="col">
                                  <label className="tituloLabel">
                                    Serviço:
                                  </label>
                                </div>
                                <div className="col">
                                  <Input
                                    className={`inputStyled ${eventStatus ? "disabled" : ""
                                      }`}
                                    value={filterItem.vlServico}
                                    disabled={eventStatus}
                                  />
                                </div>
                              </DisplayFlex>
                            </div>
                          </div>
                        </div>
                      </InfoItem>
                    </Col>
                  </ColumnIntem>
                );
              })}
          </ContainerModal>
        </ModalDadosDaNFE>
      </>
    );
  };

  // MODAL PARA REGISTRAR NOTA
  const modalRegister = () => {
    return (
      <>
        <ModalRegistroNotas>
          <DisplayFlex>
            <Close>
              <CiSquareRemove
                className="font-icon"
                onClick={!loading ? closeModalRegisterNFE : null}
                style={{ cursor: loading ? "not-allowed" : "pointer" }}
              />
            </Close>
          </DisplayFlex> 
          <div className="title">
            <strong>Você está prestes a registrar uma NF-e</strong>
            <br />
            <span>Digite os dados para ser enviado</span>
          </div>

          {/**TABS de importação de nota / digitalização da Nota */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={mostrarLeituraDaNota}
                onChange={(e, newValue) => setMostrarLeituraDaNota(newValue)}
                aria-label="basic tabs example"
              >
                <Tab label="Importar NF-e" value={0} />
                {isTabImportNFE && <Tab label="Digitalizar NF-e" value={1} />}
              </Tabs>
            </Box>

            {/**MODAL DE IMPORTAÇÃO DA NOTA */}
            <CustomTabPanel value={mostrarLeituraDaNota} index={0}>
              <ContainerModal>
                <Box sx={{ mt: 2 }} style={{width:"100%"}}>
                  {renderNFImport(modelImport[activeStep])}
                </Box>
                <InputFieldContainer>
                  {loading && <LinearProgress />}
                  <br />
                  <CustomButton
                    type="primary"
                    onClick={() => validaNFEe()}
                    disabled={loading || base64NF === null}
                  >
                    {loading ? "Enviando..." : "Enviar"}
                  </CustomButton>
                </InputFieldContainer>
              </ContainerModal>
            </CustomTabPanel>

            {/**MODAL DE DIGITALIZAÇÃO DA NOTA */}
            <CustomTabPanel value={mostrarLeituraDaNota} index={1}>
              <ContainerModal>
                {isBtnEditNFE && (
                  <div className="display-flex width-100">
                    <div className="text-align-right width-100 margin-5">
                      <ButtonEditar
                        onClick={editarField}
                      >
                        Editar
                      </ButtonEditar>
                    </div>
                  </div>
                )}
                <ColumnIntem>
                  {mensagem && (
                    <div>
                      <Alert
                        message="Por favor, confira os dados da nota antes de salvar!"
                        type="info"
                      />
                    </div>
                  )}
                  <Box sx={{ mt: 2 }}>
                    {modelInputs.map((step, index) => (
                      <div key={index}>{fieldRenderingNFE(step)}</div>
                    ))}
                  </Box>
                </ColumnIntem>

                <DisplayFlex>
                  <div className="containerBtnEdit">
                    <CustomButton type="primary" onClick={() => salvarRegisterNFE()} disabled={loading}>
                      {loading ? "Salvando..." : "Salvar"}
                    </CustomButton>
                  </div>
                </DisplayFlex>
              </ContainerModal>
            </CustomTabPanel>
          </Box>
        </ModalRegistroNotas>
      </>
    );
  };

  const alternarVisibilidade = () => {
    setValoresVisiveis(!valoresVisiveis);
  };

  // Função para verificar se todos os valores são zero
  const isAllZero = (obj) => {
    return (
      obj.vlr_total === 0 &&
      obj.vlr_sem_retencao === 0 &&
      obj.vlr_retencao === 0
    );
  };

  // Estruturação dos itens do menu baseados nos dados de dadosAnexo
  const items = Object.keys(dadosAnexo).map((key, index) => {
    const dado = dadosAnexo[key];
    const hasValues = !isAllZero(dado); // Verifica se o objeto possui valores diferentes de zero

    // Apenas no anexo V mostra mais dois campos, que são esses: CPP e valor da folha;

    return {
      key: dado.nome || index.toString(), // Chave única para cada item
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Space>
            <Badge
              className="site-badge-count-109"
              count={<DollarOutlined />}
              style={{
                backgroundColor: hasValues ? "#52c41a" : "red",
                color: "#fff",
                padding: "5px",
                borderRadius: "20px",
              }}
            />
            <span style={{ marginLeft: 8 }}>
              {`Anexo ${dado.nome || index}`}{" "}
            </span>
          </Space>
        </div>
      ),

      // Componente associado a cada item do menu
      children: (
        <>
          {/*vlr_retencao*/}
          <ContainerDadosListNFE>
            <div>
              <div className="titleText">
                <span>Valor com retenção</span>
              </div>
              <DisplayFlex>
                <div>
                  <div className="iconFont">
                    <CiBadgeDollar />
                  </div>
                </div>
                <div>
                  <div className="value">
                    <span>
                      {valoresVisiveis
                        ? dado.vlr_retencao === 0
                          ? "Sem retenção"
                          : formatValueBrl(dado.vlr_retencao)
                        : "******"}
                    </span>
                  </div>
                </div>
              </DisplayFlex>
            </div>
          </ContainerDadosListNFE>

          {/*vlr_sem_retencao */}
          <ContainerDadosListNFE>
            <div>
              <div className="titleText">
                <span>Valor sem retenção</span>
              </div>
              <DisplayFlex>
                <div>
                  <div className="iconFont">
                    <CiBadgeDollar />
                  </div>
                </div>
                <div>
                  <div className="value">
                    <span>
                      {valoresVisiveis
                        ? dado.vlr_sem_retencao === 0 ||
                          dado.vlr_sem_retencao === null
                          ? 0
                          : formatValueBrl(dado.vlr_sem_retencao)
                        : "******"}
                    </span>
                  </div>
                </div>
              </DisplayFlex>
            </div>
          </ContainerDadosListNFE>

          {/*vlr_total */}
          <ContainerDadosListNFE>
            <div>
              <div className="titleText">
                <span>Valor total</span>
              </div>
              <DisplayFlex>
                <div>
                  <div className="iconFont">
                    <CiBadgeDollar />
                  </div>
                </div>
                <div>
                  <div className="value">
                    <span>
                      {valoresVisiveis
                        ? dado.vlr_total === 0 || dado.vlr_total === null
                          ? 0
                          : formatValueBrl(dado.vlr_total)
                        : "******"}
                    </span>
                  </div>
                </div>
              </DisplayFlex>
            </div>
          </ContainerDadosListNFE>

          {dado.nome === "V" && (
            <>
              {/*ValorCPP */}
              {dado.ValorCPP !== undefined && (
                <ContainerDadosListNFE>
                  <div>
                    <div className="titleText">
                      <span>Valor CPP</span>
                    </div>
                    <DisplayFlex>
                      <div>
                        <div className="iconFont">
                          <CiBadgeDollar />
                        </div>
                      </div>
                      <div>
                        <div className="value">
                          <span>
                            {valoresVisiveis
                              ? formatValueBrl(dado.ValorCPP)
                              : "******"}
                          </span>
                        </div>
                      </div>
                    </DisplayFlex>
                  </div>
                </ContainerDadosListNFE>
              )}
              {/*valorTotalFolha */}
              {dado.valorTotalFolha !== undefined && (
                <ContainerDadosListNFE>
                  <div>
                    <div className="titleText">
                      <span>Valor da folha</span>
                    </div>
                    <DisplayFlex>
                      <div>
                        <div className="iconFont">
                          <CiBadgeDollar />
                        </div>
                      </div>
                      <div>
                        <div className="value">
                          <span>
                            {valoresVisiveis
                              ? formatValueBrl(dado.valorTotalFolha)
                              : "******"}
                          </span>
                        </div>
                      </div>
                    </DisplayFlex>
                  </div>
                </ContainerDadosListNFE>
              )}
              {/*FatorR */}
              {dado.FatorR !== undefined && (
                <ContainerDadosListNFE>
                  <div>
                    <div className="titleText">
                      <span>Valor do fator R</span>
                    </div>
                    <DisplayFlex>
                      <div>
                        <div className="iconFont">
                          <CiBadgeDollar />
                        </div>
                      </div>
                      <div>
                        <div className="value">
                          <span>
                            {valoresVisiveis
                              ? dado.FatorR === 0 || dado.FatorR === null
                                ? 0
                                : formatValueBrl(dado.FatorR)
                              : "******"}
                          </span>
                        </div>
                      </div>
                    </DisplayFlex>
                  </div>
                </ContainerDadosListNFE>
              )}
            </>
          )}
        </>
      ),
    };
  });

  const closeModalConfirmRetificacao = () => {
    setIsConfirmGerarDas(false);
  };

  const openModalConfirmRetificacao = () => {
    setIsConfirmGerarDas(false);
    setIsModalConfirmRetificacao(true);
  };

  const openModalExtratoSimples = async () => {

    const dataReferencia = dayjs(dataTermino).format('MM/YYYY');
    
    setLoading(true);
    try {
      const url = "/portal/rest/empresa/retrieve/consulta-faturamento";
      const data = {
        dataRef: dataReferencia,
       
      };

      const response = await axios.post(url, data, { withCredentials: true });

      if (response.data && response.data.length > 0 && response.status != 200 || response.status != 204 ) {
        setExtratoSimplesBase64(`data:application/pdf;base64,${response.data.base64}`);
        setModalExtrato(true);
        toast.success("Requisição efetuada com sucesso");

      } else {
        toast.error(response.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        toast.error("Erro 403 - Acesso negado");
      } else {
        console.log("Erro ao buscar os dados", error);
        toast.error("Erro ao buscar os dados", error);
      }
    } finally {
      setLoading(false);
      return;
    }
  
  };

  const openModalConfirmeRetificacao = () => {

    if (totalFaturamento > 0) {
      setIsConfirmGerarDas(false);
      setIsModalConfirmRetificacao(true);
    } else {
      setIsConfirmGerarDas(true);
    }
  };

  const handleButtonClick = (value) => {
    setIsModalConfirmRetificacao(true);
    setValueRetificacao(value);
    setIsModalConfirmRetificacao(false);
    apurarAnexoVlores(value, true);
    //alert("apurando DAS");
  };

  const apurarAnexoVlores = async (retificacao, gerarDAS = false) => {
    const url = "/portal/rest/fiscal/nf/apurar/anexos/valores";
    setLoadingFaturamento(true);
    try {
      const response = await axios.post(url, data, { withCredentials: true });
      if (response.status === 200) {
        //console.log("Resposta do data", response.data);

        const anexoData = Object.entries(response.data)
          .map(([key, value]) => ({
            nome: key,
            ...value,
          }))
          .sort((a, b) => {
            const aHasData =
              a.vlr_total !== 0 ||
              a.vlr_sem_retencao !== 0 ||
              a.vlr_retencao !== 0 ||
              a.ValorCPP !== null || a.ValorCPP !==0 ||
              a.valorTotalFolha !== null || a.valorTotalFolha !== 0 ||
              a.FatorR !== null || a.FatorR !== 0
            const bHasData =
              b.vlr_total !== 0 ||
              b.vlr_sem_retencao !== 0 ||
              b.vlr_retencao !== 0||
              b.ValorCPP !== null || b.ValorCPP !==0 ||
              b.valorTotalFolha !== null || b.valorTotalFolha !== 0 ||
              b.FatorR !== null || b.FatorR !== 0
            return bHasData - aHasData;
          });

        setDadosAnexo(anexoData);

        //const vlrRetencaoArray = anexoData.map(item => item.vlr_retencao);

        //console.log("dados anexo", dadosAnexo);

      

        if (gerarDAS) {
          // Mover a lógica de geração de DAS para cá
          const anexosArray = Object.values(anexoData);

          // Filtrar os anexos que têm valores diferentes de zero
          const anexosComValores = anexosArray.filter(
            (dados) => dados.vlr_total > 0
          );


          // Criar os detalhes apenas para os anexos com valores
          const detalhes = anexosComValores.map((dados) => {
            const fatorR = dados.hasOwnProperty("FatorR")
              ? dados.FatorR !== 0
              : false;
            const snIssRetido = dados.vlr_retencao !== 0;

            //aqui contém todas as informações necessárias para cada anexo com valores
            return {
              mercado: "Interno-Mesmo Municipio",
              fatorR: fatorR, // se tiver valor muda pra true senão fica false
              snIssRetido: snIssRetido, // se tiver valor muda pra true senão fica false
              vlFaturamento: dados.vlr_total, //totalFaturamento, // aqui vai o valor total do anexo
              vlIssPrestador: 0,
              vlIssTomador: 0,
              vlIssIntermediario: 0,
              vlIssRetido: dados.vlr_retencao,
              anexo: dados.nome,
              FatorR: dados.fatorR,
              valorCPP: dados.ValorCPP,
              valorFolha: dados.valorTotalFolha,
              valorFatorR: dados.FatorR

            };
          });

          const dataValida = new Date(dataTermino);


          const dataRef = format(dataValida, "yyyy-MM-15", { timeZone: 'UTC' });


          const objDataApuracao = {
            retificacao: retificacao,
            vlFaturamento: totalParaApuracao,
            vlFaturamentoMercadoInterno: totalParaApuracao,
            vlFaturamentoMercadoExterno: 0,
            vlIssPrestador: 0,
            vlIssTomador: 0,
            vlIssIntermediario: 0,
            issRetido: false,
            dataRef: format(dataRef, "yyyy-MM-15"),
            detalhes: detalhes,
          };

          //console.log("PAYLOAD:", objDataApuracao);

          try {
            setLoadingFaturamento(true);
            const URL_APURAR_DAS = "/portal/rest/fiscal/nf/apurar/das";
            const responseApuracao = await axios.post(
              URL_APURAR_DAS,
              objDataApuracao,
              { withCredentials: true }
            );

            if (responseApuracao.status === 200) {
              if (responseApuracao.data.erro && responseApuracao.data.erro.id === "ERRO") {
                toast.error(responseApuracao.data.erro.mensagem == null || responseApuracao.data.erro.mensagem == "" ? "Null" : responseApuracao.data.erro.mensagem);
                setLoading(false);

                return false;
              }

              const base64String = responseApuracao.data.base64;
              setPdfUrl(`data:application/pdf;base64,${base64String}`);
            } else {
              console.log("Erro ao tentar apurar");
            }
          } catch (error) {
            console.log(error);
          }


          //console.log("Mostrando o data:", objDataApuracao);
        } else {
          setPaginaAtual(anexoData[0]?.nome || "anexoI");
          setisBuscarListNF(true);
        }
      } else {
        console.log("Erro ao buscar");
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        message.error("Erro 403 - Acesso negado");
      } else {
        console.log("Erro ao buscar", error);
      }
    } finally {
      setLoadingFaturamento(false);
    }
  };

  const CloseModalStringBase64 = () => {
    setStringBase64(false);
    setPdfUrl(false);
    window.location.reload();

    setFechartudo(false);
    console.log("fechando todos os modais");
    //onClose();
  }

  const liberarParaPortal = async () => {
    const dataValida = new Date(dataTermino);
    const base64 = pdfUrl.split(',')[1];

    const dataRef = format(dataValida, "yyyy-MM-15", { timeZone: 'UTC' });
    const url = "/portal/rest/fiscal/nf/generate/guia/das";
    const data = {
      dataRef: dataRef,
      base64pdf: base64
    };

    setLoading(true);

    try {
      const response = await axios.post(url, data, { withCredentials: true });
      if (response.status === 200) {
        if (response.data.erro && response.data.erro.id === "ERRO") {
          toast.success(response.data.erro.mensagem);
          console.log(response.data.erro.mensagem);

        } else {

          //console.log("Respondendo a api: ", response.data);
          toast.success(response.data.mensagem)
          //toast.success("Tarefa concluída com sucesso!");
          setStringBase64(`data:application/pdf;base64,${response.data.base64}`);
          setLoading(false);
        }
      } else {
        toast.error("Erro ao tentar liberar para o portal")

      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        message.error("Erro 403 - Acesso negado");
      } else {
        console.log("Erro interno", error);
        toast.error("Erro interno", error)
      }
    } finally {
      setLoading(false);
    }
  };

  const onClickItem = ({ key }) => {
    if (paginaAtual === key) {
      setPaginaAtual(null); // Fecha se já estiver aberto
    } else {
      setPaginaAtual(key); // Abre o item clicado
      //console.log("Estado:", key);
    }
  };

  const modalValorFaturamento = () => {
    return (
      <>
        <ModalValorFaturamento>
          <DisplayFlex>
            <Close>
              <CiSquareRemove
                className="font-icon"
                onClick={!loading ? closeModalfaturamento : null}
                style={{ cursor: loading ? "not-allowed" : "pointer" }}
              />
            </Close>
          </DisplayFlex>

          <div className="title">
            <strong>Valor total do faturamento</strong>
            <br />
            <span>Anexos</span>
          </div>

          <DisplayFlex>
            <IconOlho onClick={alternarVisibilidade}>
              {valoresVisiveis ? <CiUnread /> : <CiRead />}
            </IconOlho>
          </DisplayFlex>

          {/* Conteúdo do modal aqui */}
          <Menu
            onClick={onClickItem}
            className="style-menu"
            defaultSelectedKeys={[paginaAtual]}
            mode="inline"
          >
            {/* Mapeia os itens do menu */}
            {items.map((item) =>
              // Verifica se o item possui children para renderizar um submenu
              item.children ? (
                <Menu.SubMenu key={item.key} title={item.label}>
                  {/* Renderiza os children do item */}
                  {item.children}
                </Menu.SubMenu>
              ) : (
                // Renderiza o item simples do menu
                <Menu.Item key={item.key}>{item.label}</Menu.Item>
              )
            )}
          </Menu>
        </ModalValorFaturamento>
      </>
    );
  };

  const closeModalfaturamento = () => {
    setisBuscarListNF(false);
  };

  const openModalConfirm = (id) => {
    setSelectedNFEId(id);
    setIsModalConfirmRemocaoNfe(true);
  };

  const closeModalConfirm = () => {
    setIsModalConfirmRemocaoNfe(false);
    setSelectedNFEId(null);
  };

  const closeModalBASE64 = () => {
    setPdfUrl(false);
  }

  const filtrarPor = async (value) => {
    if (value) {
      // Filtra os dados originais quando há um valor no input
      const numero = parseInt(value, 10);
      const BuscarNota = originalData.filter((item) => item.numero === numero);

      if (BuscarNota.length === 0) {
        toast.warning("Nenhuma NF-e com esse número foi encontrada");
        setOriginalDataVazio(true);
      } else {
        setOriginalDataVazio(false);
      }
      setData(BuscarNota);
    }
  };

  // Manipulador de clique para o botão de busca
  const buscarNFe = () => {
    if (inputSearchNfe === "") {
      toast.warn("Digite o número da nota!");
      return;
    } else {
      filtrarPor(inputSearchNfe); // Chama a função de busca passando o valor atual do input
    }
  };

  // Handler para o input de busca
  const handleInputNFe = (e) => {
    setInputSearchNfe(e.target.value); // Atualiza o estado do input com o valor digitado pelo usuário
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      buscarNFe();
    }
  };

  //EXCEL
  function flattenData(data) {
    let DadosPrimeiraTabela = [];

    data.forEach((item) => {
      let flatItem = {
        numero: item.numero,
        serie: item.serie,
        dataEmissao: item.dataEmissao,

        prestadorCnpj: item.prestadorCnpj,
        prestadorIm: item.prestadorIm,

        tomadorCep: item.tomadorCep,
        tomadorEndereco: item.tomadorEndereco,
        tomadorNumero: item.tomadorNumero,
        tomadorBairro: item.tomadorBairro,
        tomadorUf: item.tomadorUf,

        tomadorCnpj: item.tomadorCnpj,
        tomadorCpf: item.tomadorCpf,
        tomadorRazaoSocial: item.tomadorRazaoSocial,
        tomadorIm: item.tomadorIm,

        tomadorTelefone: item.tomadorTelefone,
        tomadorEmail: item.tomadorEmail,

        servicoCodigoTributacao: item.servicoCodigoTributacao,
        servicoDiscriminacao: item.servicoDiscriminacao,

        vlAliquota: item.vlAliquota,
        vlBaseCalculo: item.vlBaseCalculo,
        vlCofins: item.vlCofins,
        vlCsll: item.vlCsll,
        vlDeducao: item.vlDeducao,
        vlDescontoCondicionado: item.vlDescontoCondicionado,
        vlDescontoIncondicionado: item.vlDescontoIncondicionado,
        vlInss: item.vlInss,
        vlIr: item.vlIr,
        vlIss: item.vlIss,
        vlIssRetido: item.vlIssRetido,
        vlLiquidoNfse: item.vlLiquidoNfse,
        vlOutrosRetidos: item.vlOutrosRetidos,
        vlPis: item.vlPis,

        vlServico: item.vlServico,
      };

      DadosPrimeiraTabela.push(flatItem);
    });

    return { DadosPrimeiraTabela };
  }

  // Função para exportação para o Excel com os stylos em cada linha da tabela
  const exportToExcel = async () => {
    setLoadingExport(true);
    try {
      const DadosParaExportar = flattenData(data);

      const { DadosPrimeiraTabela } = DadosParaExportar;

      // Cria uma nova planilha
      const workbook = new ExcelJS.Workbook();
      const NomePrimeiraTabela = workbook.addWorksheet("Lista de NF-e");

      // Adiciona os títulos das colunas com cor azul
      const TitulosPrimeiraTabela = [
        'NF-e',
        "Código de verificação",
        "Data de emissão",

        "CNPJ do prestador",
        "IM do prestador",

        "CEP do tomador",
        "Endereço do tomador",
        "Número",
        "Bairro do tomador",
        "UF tomador",

        "CNPJ do tomador",
        "CPF do tomador",
        "Razão social do tomador",
        "IM do tomador",

        "Telefone do tomador",
        "E-mail do tomador",

        "Código da discriminação",
        "Serviço de discriminação",

        "Valor Alíquota",
        "Valor base de calculo",
        "Valor Cofins",
        "Valor vlCsll",
        "Valor dedução",
        "Valor desconto condicionado",
        "Valor desconto incondicionado",
        "Valor INSS",
        "Valor IR",
        "Valor ISS",
        "Valor ISS retido",
        "Valor líquido da NF-e",
        "Outros valores retidos",
        "Valor PIS",

        "Valor serviço",
      ];
      const headerRow = NomePrimeiraTabela.addRow(TitulosPrimeiraTabela);
      headerRow.font = {
        bold: true,
        color: { argb: 'FF0361A7' }, // Cor da fonte (azul)
        size: 12
      };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3E2F4' } // Cor de fundo clara para os cabeçalhos das colunas
      };

      // Adiciona os dados principais e aplica a cor alternada
      DadosPrimeiraTabela.forEach((item, index) => {
        const row = NomePrimeiraTabela.addRow([
          item.numero,
          item.serie,
          item.dataEmissao,

          item.prestadorCnpj,
          item.prestadorIm,

          item.tomadorCep,
          item.tomadorEndereco,
          item.tomadorNumero,
          item.tomadorBairro,
          item.tomadorUf,

          item.tomadorCnpj,
          item.tomadorCpf,
          item.tomadorRazaoSocial,
          item.tomadorIm,

          item.tomadorTelefone,
          item.tomadorEmail,

          item.servicoCodigoTributacao,
          item.servicoDiscriminacao,

          item.vlAliquota,
          item.vlBaseCalculo,
          item.vlCofins,
          item.vlCsll,
          item.vlDeducao,
          item.vlDescontoCondicionado,
          item.vlDescontoIncondicionado,
          item.vlInss,
          item.vlIr,
          item.vlIss,
          item.vlIssRetido,
          item.vlLiquidoNfse,
          item.vlOutrosRetidos,
          item.vlPis,

          item.vlServico,
        ]);
        row.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: index % 2 === 0 ? 'FFD9D9D9' : 'FFF2F2F2' } // Alterna entre #D9D9D9 e #F2F2F2
        };
      });

      // Ajusta a largura das colunas de acordo com o conteúdo
      NomePrimeiraTabela.columns.forEach(column => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const length = cell.value ? cell.value.toString().length : 0;
          if (length > maxLength) {
            maxLength = length;
          }
        });
        column.width = Math.max(10, maxLength + 2); // Adiciona um buffer para a largura
      });

      // Salva o arquivo Excel
      await workbook.xlsx.writeBuffer().then((buffer) => {
        const url = window.URL.createObjectURL(new Blob([buffer]));
        const a = document.createElement('a');
        a.href = url;
        a.download = 'NFE.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      });
      setLoadingExport(false);

      setTimeout(() => {
        toast.success("Arquivo baixado com sucesso!");
      }, 2000);

      setTimeout(() => {
      }, 3000);
    } catch (error) {
      toast.error("Falha ao exportar o arquivo.");
    }
  };

  const selectServices = (selectedValue) => {
    // Se o usuário escolher a mesma opção novamente, reseta primeiro
    if (valueSelectService === selectedValue) {
      setValueSelectService(null); // Força reset
      setTimeout(() => setValueSelectService(selectedValue), 0);
    } else {
      setValueSelectService(selectedValue);
    }
  
    if (selectedValue === 1) {
      openModalExtratoSimples();
    }
    if (selectedValue === 2) {
      setModalServicos(true);
    }
  };

  const onChange = (e) => {
    setFiltrarCanceladas(e.target.checked);
  };

  const dadosFiltrados = filtrarCanceladas
  ? slicedData.filter(item => item.cancelada === true)
  : slicedData;

  const getStatus = (cancelada) => {
    return (
      <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <StatusDot color={cancelada ? "red" : "green"} />
        {cancelada ? "Cancelada" : "Emitida"}
      </span>
    );
  };
  
  return (
    <>
      <Container>
        {notasFiscais && (
          <>
            {/* COMPONENT CAMPOS DE FILTER INICIAL*/}
            <TableFilterNF>
              <DisplayFlex2>
                <div className="modalTitle">
                  <label className="title">
                    Notas Fiscais
                  </label>
                  <p className="subtitle">
                    Gerencie as Notas Fiscais de sua empresa.
                  </p>
                </div>

                {isVlrTotal && (
                  <div className="modalInfo">
                    <div>
                      <label>Valor do faturamento atual</label>
                      <br />
                      <div className="vlrFat">
                        {loading ? (
                          // Mostra Skeleton enquanto carrega
                          <>
                            {[...Array(1)].map((_, index) => (
                              <>
                                <Spin />
                              </>
                            ))}
                          </>
                        ) : (
                          // Mostra o valor total quando terminar de carregar
                          <>
                            <span>{faturamentoFormatado}</span>
                            <br />
                            {isEmitirRelatorioFaturamento && (
                              <div>
                                {loadingFaturamento ? (
                                  <div className="container-loading">
                                    <LoadingCircle />
                                  </div>
                                ): (
                                  <Popover placement="right" content={"Mostrar faturamento por anexo"}>
                                    <BtnUpload
                                      onClick={() => apurarAnexoVlores()}
                                      disabled={loading}
                                    >
                                      <FileTextOutlined />
                                    </BtnUpload>
                                  </Popover>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </DisplayFlex2>

              <div className="display-flex">
                <div className="margin-5">
                  <ConfigProvider locale={pTBR}>
                    <DatePicker
                      defaultValue={dayjs(dateFormat)}
                      value={dataInicio}
                      onChange={onChangeValueDateInicio}
                      format={dateFormat}
                    />
                  </ConfigProvider>
                </div>

                <div className="margin-5">
                  <ConfigProvider locale={pTBR}>
                    <DatePicker
                      defaultValue={dayjs(dateFormat)}
                      value={dataTermino}
                      onChange={onChangeValueDateFim}
                      format={dateFormat}
                      onKeyDown={handleKeyDownBuscar}
                    />
                  </ConfigProvider>
                </div>

                <div className="margin-5">
                  <Tooltip title="Buscar">
                    <CustomButton loading={loading} type="primary" shape="circle" icon={<SearchOutlined />} onClick={fetchDataBusca}/>
                  </Tooltip>
                </div>

                <div className="margin-5">
                  <Tooltip title="Adicionar">
                    <CustomButton loading={loading} type="primary" shape="circle" icon={<PlusOutlined />} onClick={openModalRegisterNFE}/>
                  </Tooltip>
                </div>

                {loading ? (
                  <SkeletonContainer>
                    <LoadingCircle />
                    <BtnSkeleton />
                    <BtnSkeleton />
                </SkeletonContainer>
                ):(
                  <>
                    <div style={{margin: 5}}>
                      <Select
                        style={{width: 220}}
                        value={valueSelectService}
                        onChange={selectServices}
                        defaultValue={"Selecionar"}
                        options={[
                          {
                            value: 1,
                            label: 'Extrato Simples Nacional',
                          },
                          {
                            value: 2,
                            label: 'Serviços',
                          },
                        ]}
                      />
                    </div>

                    <div className="margin-5">
                      {/*isBtnGerarDAS && ( */}
                        <button
                          className="btn-to-generate-das"
                          onClick={openModalConfirmeRetificacao}
                          >
                          <BuildOutlined /> Gerar DAS
                        </button>
                    </div>
                  </>
                )}    
              </div>

              {/**Filtrar nota e exportar filtro ou o data para o excel */}
              {isBuscaNFe && (
                <ContainerSearch>
                  <div className="margin-right">
                    <Input onKeyDown={handleKeyDown} type="text" value={inputSearchNfe} onChange={handleInputNFe} placeholder="Número da NF-e" />
                  </div>

                  <div className="margin-right">
                    <Tooltip title="Buscar NFE">
                      <CustomButton type="primary" shape="circle" icon={<SearchOutlined />} onClick={buscarNFe}/>
                    </Tooltip>
                  </div>

                  <div className="margin-right">
                    <Checkbox onChange={onChange}>Canceladas</Checkbox>                  
                  </div>

                  <div>
                    {loadingExport ? (
                      <>
                      <SkeletonContainer>
                        <LoadingCircle/>
                        <BtnSkeleton/>
                      </SkeletonContainer>
                      </>
                    ):(
                      <Button onClick={exportToExcel}> <FileExcelOutlined /> Exportar</Button>
                    )}
                  </div>
                </ContainerSearch>
              )}

            </TableFilterNF>

            {/* TABELA DE NF-e */}
            {isTable && (
              <>
                <TableHeader>
                  {/*TITULO DA TABELA VINDO DE UM JSON*/}
                  <TableHead>
                    {titleTable[0].titles.map((item, index) => {
                      return (
                        <ColumnTitle key={index} id={index}>
                          <TableTitle>
                            <strong className="style-color-font-size">{item.title}</strong>
                          </TableTitle>
                        </ColumnTitle>
                      );
                    })}
                  </TableHead>
                </TableHeader>

                <TableContainer>
                  {loading && (
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress />
                    </Box>
                  )}
                  <TableBody>
                    {loading ? (
                      <>
                        {[...Array(10)].map((_, index) => (
                          <Skeleton
                            key={index}
                            variant="rectangular"
                            width="100%"
                            height={40}
                          />
                        ))}
                      </>
                    ) : (
                      // aqui ele faz um map nas notas que vem da api, depois eu faço um map para trazer as info de cada nt (para diminuir code)
                      dadosFiltrados.length === 0 ? (
                        <Alert message="Nenhum Movimento Encontrado!" type="warning" showIcon />
                      ) : (
                        dadosFiltrados.map((item) => (
                            <div key={item.id} onClick={() => openModalDetails(item.id)}>
                              <TableRow cancelada={item.cancelada === true}>
                                {[
                                  item.numero, 
                                  item.serie === "" || item.serie === null ? "Não definido" : item.serie, 
                                  item.dataEmissao ? dayjs(item.dataEmissao).format("DD/MM/YYYY") : "",
                                  item.tomadorUf === "" || item.tomadorUf === null ? "Não definido" : item.tomadorUf, 
                                  formatCurrency(item.vlInss),
                                  formatCurrency(item.vlBaseCalculo),
                                  formatCurrency(item.vlServico), 
                                  getStatus(item.cancelada), 
                                  <DisplayFlex key="actions">
                                    <Flex wrap gap="small">
                                      <Button 
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            openModalConfirm(item.numero);
                                          }}
                                          loading={loading}
                                        >
                                          Excluir
                                        </Button>
                                    </Flex>
                                  </DisplayFlex>
                                ].map((content, i) => (
                                  <TableColumn key={i}>
                                    {typeof content === "string" || typeof content === "number" ? (
                                        <span>{content}</span>
                                      ) : (
                                        content
                                      )}
                                  </TableColumn>
                                ))}
                              </TableRow>
                            </div>
                          )
                        )
                      )
                    )}
                    {loading ? (
                      <>
                        <span>Carregando...</span>
                      </>
                    ) : (
                      <PaginationBtn>
                        <Stack spacing={1}>
                          <Pagination
                            count={Math.ceil(data.length / Numberpage)}
                            page={page}
                            onChange={handleChangePage}
                            size="small"
                          />
                        </Stack>
                      </PaginationBtn>
                    )}
                  </TableBody>
                </TableContainer>
              </>
            )}
          </>
        )}

        {togenerate && (
          <DasContainer>
            <DasCommentContainer>
              <FieldContainer>
                <InputFieldContainer>
                  <InputField type="text" placeholder="Comentário" />
                </InputFieldContainer>
              </FieldContainer>
            </DasCommentContainer>
            <XmlContainer>XML</XmlContainer>
          </DasContainer>
        )}

        {/**ABRE MODAL QUANDO O USUÁRIO CLICA NO MODAL DE CADA NOTA */}
        {isModalDetail && (
          <>
            <ModalOverlay />
            <ModalContent>
              <div className="modal-content">{modalDetails(isModalDetail)}</div>
            </ModalContent>
          </>
        )}

        {/**ABRE MODAL QUANDO O USUÁRIO CLICA EM "ADICIONAR" */}
        {isRegisterNFImport && (
          <>
            <ModalOverlay />
            <div className="modal-content">{modalRegister()}</div>
          </>
        )}

        {isBuscarListNF && (
          <>
            <ModalOverlay />
            <div className="modal-content">{modalValorFaturamento()}</div>
          </>
        )}

        {/*Esse modal aparece quando ele clica em excluir */}
        {isModalConfirmRemocaoNfe && (
          <>
            <Modal title="Remover" open={isModalConfirmRemocaoNfe} okText='Sim' cancelText='Não' onOk={() => deleteRegisterNFE(selectedNFEId)} onCancel={closeModalConfirm}>
              <p>Tem certeza que deseja excluir a NF-e <strong>{selectedNFEId}</strong>?</p>
            </Modal>
          </>
        )}

        {/* Esse modal vai aparecer quando ele clicar em gerar DAS */}
        {isConfirmGerarDas && (
          <Modal
            title="Importante!!!"
            open={isConfirmGerarDas}
            okText="Sim"
            cancelText="Não"
            onOk={openModalConfirmRetificacao} // Chama a função para abrir o próximo modal
            onCancel={closeModalConfirmRetificacao} // Fecha o modal de geração de DAS
          >
            <p>Você tem certeza que deseja gerar a DAS sem movimento?</p>
          </Modal>
        )}

        {/* Esse modal aparece para confirmar a retificação */}
        {isModalConfirmRetificacao && (
          <Modal
            title="Importante!!!"
            open={isModalConfirmRetificacao}
            okText="Sim"
            cancelText="Não"
            onOk={() => handleButtonClick(2)} // Confirma a retificação
            onCancel={() => handleButtonClick(1)}
          >
            <p>Deseja enviar essa declaração como retificada?</p>
          </Modal>
        )}

        {pdfUrl && (
          <>
            <ModalOverlay />
            <ModalBASE64>
              <DisplayFlex>
                <Close>
                  <CiSquareRemove
                    className="font-icon"
                    onClick={closeModalBASE64}
                  />
                </Close>
              </DisplayFlex>

              <iframe className="form-iframe" src={pdfUrl} />
              <div className="text-align-right">
                <Button className="btn-cancel" loading={loading}>
                  Cancelar
                </Button>
                <Button
                  className="btn-confirm-base-64"
                  onClick={() => liberarParaPortal()}
                  loading={loading}
                  type="primary"
                >
                  Liberar no portal
                </Button>
              </div>
            </ModalBASE64>
          </>
        )}

        {/*Esse modal recebe o base64 depois que é gerado o das e clicar em "Liberar no portal" */}
        {stringBase64 && (
          <>
            <ModalOverlay />
            <ModalBASE64>
              <DisplayFlex>
                <Close>
                  <CiSquareRemove
                    className="font-icon"
                    onClick={CloseModalStringBase64}
                  />
                </Close>
              </DisplayFlex>
              <iframe className="form-iframe" src={stringBase64} />
            </ModalBASE64>
          </>
        )}

        {modalExtratoSimplesDas && (
          <>
            <ModalOverlay />
            <ModalBASE64>
              <DisplayFlex>
                <Close>
                  <CiSquareRemove
                    className="font-icon"
                    onClick={() => {setModalExtrato(false)}}
                  />
                </Close>
              </DisplayFlex>
              <iframe className="form-iframe" src={extratoSimplesBase64} />
            </ModalBASE64>
          </>
        )}

        {modalServicos && (
          <>
            <ModalOverlay/>
            <ClassificacaoServicos setModalServicos={setModalServicos}/>
          </>
        )}
      </Container>
    </>
  );
}
export default NotaFiscal;